import React from "react";
import Style from "./loader.module.css";

function Spinner() {
  return (
    <div className="flex justify-center items-center h-full my-8 ">
      <style>{`
       
      `}</style>
      <p className={Style.loader}></p>
    </div>
  );
}

export default Spinner;
